import React, { useMemo } from 'react';
import useConstant from 'use-constant';
import type { HSPos } from '@types';
import Tabbar from '../../Tabbar';
import WidgetRow from '../WidgetRow';
import IconBottom from './IconBottom';
import IconTop from './IconTop';
import IconLeft from './IconLeft';
import IconRight from './IconRight';

interface Props {
  value: HSPos;
  reversed?: boolean;
  onChange: (pos: HSPos) => void;
}

function WidgetRowTitlePos({ value, reversed, onChange }: Props) {
  const values: HSPos[] = useConstant(() =>
    reversed
      ? ['bottom', 'top', 'right', 'left']
      : ['top', 'bottom', 'left', 'right']
  );
  const tabs = reversed
    ? [
        <IconTop active={value === 'bottom'} />,
        <IconBottom active={value === 'top'} />,
        <IconLeft active={value === 'right'} />,
        <IconRight active={value === 'left'} />,
      ]
    : [
        <IconTop active={value === 'top'} />,
        <IconBottom active={value === 'bottom'} />,
        <IconLeft active={value === 'left'} />,
        <IconRight active={value === 'right'} />,
      ];
  const activeIndex = useMemo(
    () => values.findIndex((x) => x === value) ?? 0,
    [value, values]
  );

  return (
    <WidgetRow>
      <div className="mb-10">标题方向：</div>
      <Tabbar
        tabs={tabs}
        tips={['上方', '下方', '左侧', '右侧']}
        activeIndex={activeIndex}
        onChange={(index) => onChange(values[index])}
      />
    </WidgetRow>
  );
}

export default WidgetRowTitlePos;
